<div *transloco="let t; scope: 'featureDataManagement'" class="flex flex-col">
  <div class="mb-8">
    <span class="bd-label-regular" data-id="attributes-editor-title">
      {{ t('featureDataManagement.attributesEditor.title') }}
    </span>
  </div>
  <div class="flex flex-col" [formGroup]="editorForm">
    <div class="flex bd-column-header">
      <span
        class="bd-label-regular bd-name-column"
        data-id="attributes-editor-name-column-header"
      >
        {{ t('featureDataManagement.attributesEditor.nameColumnHeader') }}
      </span>
      <span
        class="bd-label-regular"
        data-id="attributes-editor-type-column-header"
      >
        {{ t('featureDataManagement.attributesEditor.typeColumnHeader') }}
      </span>
    </div>
    @for (attributeGroup of attributeGroupsArray; track $index) {
      <div [formGroup]="attributeGroup" class="mb-6">
        <div class="flex">
          <div class="flex flex-col bd-name-column">
            <input
              name="attributeNameInput"
              type="text"
              pInputText
              autocomplete="off"
              [placeholder]="
                t('featureDataManagement.attributesEditor.nameInputPlaceholder')
              "
              formControlName="name"
              [attr.data-id]="'attributes-editor-name-input_' + $index"
              (keydown.enter)="formatNameValue(attributeGroup.controls['name'])"
              (blur)="formatNameValue(attributeGroup.controls['name'])"
            />
            @let nameControl = attributeGroup.controls['name'];
            @if (
              (nameControl.dirty || nameControl.touched) && nameControl.invalid
            ) {
              <bd-helper-text
                [attr.data-id]="'attributes-editor-name-error-msg_' + $index"
                [text]="
                  t(
                    `featureDataManagement.attributesEditor.errorMessages.attributeName.${firstError($index, 'name')}`
                  )
                "
                state="error"
                class="mt-2"
              ></bd-helper-text>
            }
            @if (attributeGroup.value.type === 'money') {
              <bd-currency-selector
                class="mt-4"
                (selectedCurrencyChange)="
                  onSelectedCurrencyChange($event, attributeGroup)
                "
              ></bd-currency-selector>
            }
          </div>
          <div class="flex">
            <div class="flex flex-col bd-type-column">
              <p-select
                name="typeInput"
                [options]="attributeTypeOptions"
                optionLabel="label"
                optionValue="value"
                [placeholder]="
                  t(
                    'featureDataManagement.attributesEditor.typeInputPlaceholder'
                  )
                "
                formControlName="type"
                [attr.data-id]="'attributes-editor-type-input_' + $index"
                class="w-full"
              />
              @let typeControl = attributeGroup.controls['type'];
              @if (
                (typeControl.dirty || typeControl.touched) &&
                typeControl.invalid
              ) {
                <bd-helper-text
                  [attr.data-id]="'attributes-editor-type-error-msg_' + $index"
                  [text]="
                    t(
                      `featureDataManagement.attributesEditor.errorMessages.attributeType.${firstError($index, 'type')}`
                    )
                  "
                  state="error"
                  class="mt-2"
                ></bd-helper-text>
              }
            </div>
            <p-button
              class="ml-4"
              [outlined]="true"
              styleClass="bd-danger"
              icon="ui-delete"
              [disabled]="
                attributeGroup.pristine && attributesFormArray.length <= 1
              "
              (onClick)="onRemoveAttributeButtonClick($index)"
            />
          </div>
        </div>
        @if (attributeGroup.value.type === 'enum') {
          <div class="mt-4">
            <bd-enum-options-editor
              [control]="attributeGroup.controls['enumValues']"
            ></bd-enum-options-editor>
          </div>
        } @else if (attributeGroup.value.type === 'reference') {
          <div class="mt-4 flex">
            @let referenceTypeControl =
              attributeGroup.controls['referenceType'];
            @let hasError =
              (referenceTypeControl.dirty || referenceTypeControl.touched) &&
              referenceTypeControl.invalid;
            <bd-dropdown
              [attr.data-id]="'reference-type-input_' + $index"
              class="bd-type-column"
              [settings]="{
                dropdownLabelKey: 'attributesEditor.selectReferenceType.label',
                tScope: 'featureDataManagement',
                inputPlaceholderKey:
                  'attributesEditor.selectReferenceType.placeholder',
                inputType: 'default',
                layout: 'list',
                selectionMode: 'single',
                dropdownWidth: '230px',
              }"
              [options]="objectTypeOptions"
              formControlName="referenceType"
              [errorMessage]="
                hasError
                  ? t(
                      'featureDataManagement.attributesEditor.selectReferenceType.validationMessages.' +
                        firstError($index, 'referenceType')
                    )
                  : undefined
              "
              [state]="hasError ? 'error' : 'default'"
            />
          </div>
        }
      </div>
    }
  </div>
  <div>
    <p-button
      [text]="true"
      [label]="t('featureDataManagement.addNewButton')"
      icon="ui-plus"
      iconPos="right"
      data-id="attributes-editor-add-attribute-button"
      (onClick)="onAddAttributeButtonClick()"
    />
  </div>
</div>
